import React, { useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faDatabase, faSdCard, faCode, faWifi, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from '../context/TranslationContext';
import { AuthContext } from '../context/AuthContext';
import RagArticlesIndex from './RagArticlesIndex';
import debug from '@commons-shared/debug';

const AdminDrawer = ({ isOpen, onClose }) => {
  const { t, loadPageTranslations } = useTranslation();
  const { user } = React.useContext(AuthContext);

  const adminNavItems = [
    {
      to: '/admin',
      icon: faDatabase,
      label: 'NAV_ADMIN',
      defaultLabel: 'Administration'
    },
    {
      to: '/circuit-breaker-test',
      icon: faWifi,
      label: null,
      defaultLabel: 'Circuit Breakers'
    },
    {
      to: '/cache-admin',
      icon: faSdCard,
      label: 'NAV_CACHE_ADMIN',
      defaultLabel: 'Cache'
    },
    {
      to: '/client-data',
      icon: faCode,
      label: 'NAV_CLIENT_DATA',
      defaultLabel: 'Données Dynamiques'
    },
    {
      to: '/rag-management',
      icon: faGraduationCap,
      label: 'NAV_RAG_MANAGEMENT',
      defaultLabel: 'Gestion RAG'
    }
  ];

  // Charger les traductions admin
  useEffect(() => {
    const loadTranslations = async () => {
      try {
        await loadPageTranslations('NAVIGATION');
        await loadPageTranslations('CIRCUIT_BREAKER');
        debug.log('AdminDrawer', 'Traductions NAVIGATION et CIRCUIT_BREAKER chargées');
      } catch (error) {
        debug.error('AdminDrawer', 'Erreur lors du chargement des traductions:', error);
      }
    };

    loadTranslations();
  }, [loadPageTranslations]);

  // Fermer le drawer quand on clique sur un lien
  const handleNavLinkClick = () => {
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="wa-admin-drawer-overlay"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Drawer */}
      <div className={`wa-admin-drawer ${isOpen ? 'wa-admin-drawer--open' : ''}`}>
        {/* Header du drawer */}
        <div className="wa-admin-drawer-header">
          <h2 className="wa-admin-drawer-title">
            {t('NAVIGATION', 'ADMIN_TOOLS', 'Outils d\'Administration')}
          </h2>
          <button
            className="wa-admin-drawer-close"
            onClick={onClose}
            aria-label="Fermer le menu d'administration"
            title="Fermer"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Contenu du drawer */}
        <nav className="wa-admin-drawer-nav">
          <ul className="wa-admin-drawer-list">
            {adminNavItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `wa-admin-drawer-link ${isActive ? 'wa-admin-drawer-link--active' : ''}`
                  }
                  onClick={handleNavLinkClick}
                  title={item.label ? t('NAVIGATION', item.label, item.defaultLabel) : item.defaultLabel}
                >
                  <FontAwesomeIcon icon={item.icon} />
                  <span>
                    {item.label ? t('NAVIGATION', item.label, item.defaultLabel) : item.defaultLabel}
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer du drawer */}
        <div className="wa-admin-drawer-footer">
          <p className="text-xs text-gray-500">
            Outils de débogage et d'administration
          </p>
        </div>
      </div>
    </>
  );
};

export default AdminDrawer;
